import React from 'react';

export const IconHamburger = () => (
  <svg width="16" height="11" viewBox="0 0 16 11">
    <g stroke="#E58061" fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M.5.5h15M.5 5.5h15M.5 10.5h15"/>
    </g>
  </svg>
);
